export const MAX_VIEWERS = 9;
export const MAX_SIDE_BY_SIDE_VIEWERS = 2;
